const prefersReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)"
).matches;

document.querySelectorAll(".intro-block__design-elements").forEach((el) => {
  // Skip animation entirely for users who prefer reduced motion —
  // the CSS already removes clip-path, but we still add .is-visible
  // so the paths are fully visible without animating.
  if (prefersReducedMotion) {
    el.classList.add("is-visible");
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          el.classList.add("is-visible");
          obs.unobserve(el);
        }
      });
    },
    { threshold: 0.1 }
  );

  observer.observe(el);
});
